<p class="text-xs" [innerHTML]="data.info"></p>